import type { Company } from "./company";
import type { ProviderCredentials, ProviderPolicies } from "./credentials";
import type { IntegrationName } from "./integration";

export const companyProviders = ["google", "microsoft", "dropbox"] as const;

export type CompanyProvider = (typeof companyProviders)[number];

export const companyCredentialsTypes = ["integration", "sso", "mailbox"] as const;

export type CompanyCredentialsTypes = (typeof companyCredentialsTypes)[number];

export interface CompanyProviderAccess {
	files: boolean;
	mailbox: boolean;
}

export const accountProviders = ["google", "microsoft"] as const satisfies CompanyProvider[];

export type AccountProvider = (typeof accountProviders)[number];

export const accountIntegrationNames: Record<AccountProvider, IntegrationName> = {
	google: "google-drive",
	microsoft: "sharepoint",
};

export interface ConnectedAccount {
	provider: AccountProvider;
	access: CompanyProviderAccess;
	connected: CompanyProviderAccess;
	accountEmail: string | undefined;
}

export interface CompanyCredentials {
	id: string;
	type: CompanyCredentialsTypes;
	provider: CompanyProvider;
	credentials: ProviderCredentials;
	createdAt: Date;
	updatedAt: Date;
	policies?: ProviderPolicies | undefined;
	company?: Company | undefined;
	expiredAt?: Date | undefined;
}
